import React from "react";
import { Content, ContentBlock } from "@onelogin/react-components";

const MessageScreen = ({ children }) => (
  <Content data-testid="self-registration-success">
    <ContentBlock>
      {children}
    </ContentBlock>
  </Content>
);

export default MessageScreen;
